module.exports = {
      id: "podcast-usage",
      viewBox: "0 0 104.071 88.89",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#podcast",
      toString: function () {
        return this.url;
      }
    }